import { combineReducers } from 'redux';
import unitesReducer from './unitesReducer';
import fractionsReducer from './fractionsReducer';
import visibilityNumbersReducer from './visibilityNumbersReducer';

export default combineReducers({
    unites: unitesReducer,
    fractions: fractionsReducer,
    visibilityNumbers: visibilityNumbersReducer,
});
